import type { CapitalGlobalProposalAddressFieldPrefix } from '@/features/proposals/components/capital-global/constants/capital-global-proposal-address-field-names.constant';
import type { CapitalGlobalProposalStepDadosDoSeguroValues } from '@/features/proposals/schemas/capital-global/proposal-step-dados-do-seguro.schema';
import type { CapitalGlobalProposalAddressPayload } from '@/services/proposals/types';

function readRegistrationAddress(
  values: CapitalGlobalProposalStepDadosDoSeguroValues
): CapitalGlobalProposalAddressPayload {
  return {
    zipCode: values.registrationCep,
    street: values.registrationStreet,
    streetNumber: values.registrationNumber,
    complement: values.registrationComplement,
    neighborhood: values.registrationNeighborhood,
    city: values.registrationCity,
    state: values.registrationState,
  };
}

function readCorrespondenceAddress(
  values: CapitalGlobalProposalStepDadosDoSeguroValues
): CapitalGlobalProposalAddressPayload {
  return {
    zipCode: values.correspondenceCep,
    street: values.correspondenceStreet,
    streetNumber: values.correspondenceNumber,
    complement: values.correspondenceComplement,
    neighborhood: values.correspondenceNeighborhood,
    city: values.correspondenceCity,
    state: values.correspondenceState,
  };
}

export function mapFormAddressToCapitalGlobalProposalAddress(
  values: CapitalGlobalProposalStepDadosDoSeguroValues,
  prefix: CapitalGlobalProposalAddressFieldPrefix
): CapitalGlobalProposalAddressPayload {
  return prefix === 'registration'
    ? readRegistrationAddress(values)
    : readCorrespondenceAddress(values);
}
